import type { FileID } from './db.ts';

export interface EquipmentReference {
  description: string;
  material: string;
  productUrl: string;
  photoFileID: FileID | null;
}
export type ContainmentReference = EquipmentReference & { name: string };
export interface StorageEquipmentDetails {
  container: EquipmentReference;
  containment: ContainmentReference;
}
export function equipmentReferenceEmpty(): EquipmentReference {
  return { description: '', material: '', productUrl: '', photoFileID: null };
}
export function containmentReferenceEmpty(): ContainmentReference {
  return { ...equipmentReferenceEmpty(), name: '' };
}
export function storageEquipmentDetailsEmpty(): StorageEquipmentDetails {
  return { container: equipmentReferenceEmpty(), containment: containmentReferenceEmpty() };
}
